import logo from "../../Assets/images/protika.png";
import MyTimer from "./Timer";
import axios from "axios";
import {useState, useEffect} from "react";
import {useNavigate} from "react-router";
import useAuth from "../../hooks/Auth";
import {toast} from "react-toastify";
import {prefixUrl} from "../../Utils/utilsData";

const Verify = (props) => {

  const [code, setCode] = useState({
    firstDigit: "",
    secondDigit: "",
    thirdDigit: "",
    fourthDigit: "",
    fifthDigit: "",
  });
  const time = new Date();
  time.setTime(time.getTime() + 1000 * 60);
  const navigate = useNavigate();
  const {setAuth} = useAuth();
  const changeForm = () => {
    if (props.type === "register") {
      props.setContent("register");
    } else if (props.type === "login") {
      props.setContent("login");
    }
  };

  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
  useEffect(() => {
    let sendData = {};
    const myCodd = code.firstDigit + code.secondDigit + code.thirdDigit + code.fourthDigit + code.fifthDigit
    if (props.type === "register") {
      sendData = {
        phoneNumber: localStorage.getItem("mobile"),
        fullName: localStorage.getItem("name"),
        registerCode: p2e(myCodd),
      };
    } else if (props.type === "login") {
      sendData = {
        phoneNumber: localStorage.getItem("mobile"),
        LoginCode: p2e(myCodd),
      };
    }
    if (myCodd.length === 5) {
      const url =
        props.type === "register"
          ? `${prefixUrl()}/register/confrm.php`
          : `${prefixUrl()}/login/confrm.php`;
      axios.post(url, sendData).then((res) => {
        if (res.data.status) {
          setAuth(res.data.output.token);
          localStorage.setItem("name", res.data.output.fullName);
          setTimeout(() => {
            navigate("/");
          }, 500);
        } else {
          toast.error(res.data.output.error);
        }
      });
    }
  }, [code]);

  const putCodeInPlace = (t, idT, valueT) => {
    idT === "1"
      ? (t.firstDigit = valueT)
      : idT === "2"
        ? (t.secondDigit = valueT)
        : idT === "3"
          ? (t.thirdDigit = valueT)
          : idT === "4"
            ? (t.fourthDigit = valueT)
            : idT === "5"
              ? (t.fifthDigit = valueT)
              : (t.none = "");
    return t;
  };
  const OnKeyUpCode = (event) => {
    if (event.target.value.length > 1) {
      event.target.value = event.target.value[0];
    }
    const acceptedKeys = "1234567890";
    const key = event.key;
    if (key === "Backspace" || key === "Delete") {
      const t = {...code};
      setCode(putCodeInPlace(t, event.target.id, event.target.value));
      if (event.target.previousElementSibling === null) {
        event.target.value = "";
      } else {
        event.target.value = "";
        event.target.previousElementSibling.focus();
        event.target.previousElementSibling.select();
      }
    } else if (event.key === "Tab") {
      if (event.target.nextElementSibling !== null) {
        event.target.nextElementSibling.select();
      }
    } else if (acceptedKeys.includes(event.key)) {
      const t = {...code};
      setCode(putCodeInPlace(t, event.target.id, event.target.value));
      if (event.target.nextElementSibling === null) {
      } else {
        // event.target.nextElementSibling.value = ''
        event.target.nextElementSibling.focus();
        event.target.nextElementSibling.select();
      }
    } else {
      event.target.value = "";
    }
  };

  return (
    <div className="login-form entercode-form">
      <div className="login-logo">
        <img src={logo} alt=""/>
      </div>
      <span className="login-text">کد ورود به آدرس زیر ارسال شد</span>
      <div className="code-address">
        <img src="Images/edit.svg" alt=""/>
        <span className="reciever">
          <svg
            onClick={changeForm}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M15 23.25H9C3.57 23.25 1.25 20.93 1.25 15.5V9.5C1.25 4.07 3.57 1.75 9 1.75H11C11.41 1.75 11.75 2.09 11.75 2.5C11.75 2.91 11.41 3.25 11 3.25H9C4.39 3.25 2.75 4.89 2.75 9.5V15.5C2.75 20.11 4.39 21.75 9 21.75H15C19.61 21.75 21.25 20.11 21.25 15.5V13.5C21.25 13.09 21.59 12.75 22 12.75C22.41 12.75 22.75 13.09 22.75 13.5V15.5C22.75 20.93 20.43 23.25 15 23.25Z"
              fill="#EE6900"
            />
            <path
              d="M8.49935 18.1901C7.88935 18.1901 7.32935 17.9701 6.91935 17.5701C6.42935 17.0801 6.21935 16.3701 6.32935 15.6201L6.75935 12.6101C6.83935 12.0301 7.21935 11.2801 7.62935 10.8701L15.5093 2.99006C17.4993 1.00006 19.5193 1.00006 21.5093 2.99006C22.5993 4.08006 23.0893 5.19006 22.9893 6.30006C22.8993 7.20006 22.4193 8.08006 21.5093 8.98006L13.6293 16.8601C13.2193 17.2701 12.4693 17.6501 11.8893 17.7301L8.87935 18.1601C8.74935 18.1901 8.61935 18.1901 8.49935 18.1901ZM16.5693 4.05006L8.68935 11.9301C8.49935 12.1201 8.27935 12.5601 8.23935 12.8201L7.80935 15.8301C7.76935 16.1201 7.82935 16.3601 7.97935 16.5101C8.12935 16.6601 8.36935 16.7201 8.65935 16.6801L11.6693 16.2501C11.9293 16.2101 12.3793 15.9901 12.5593 15.8001L20.4393 7.92006C21.0893 7.27006 21.4293 6.69006 21.4793 6.15006C21.5393 5.50006 21.1993 4.81006 20.4393 4.04006C18.8393 2.44006 17.7393 2.89006 16.5693 4.05006Z"
              fill="#EE6900"
            />
            <path
              d="M19.8496 10.3298C19.7796 10.3298 19.7096 10.3198 19.6496 10.2998C17.0196 9.55978 14.9296 7.46978 14.1896 4.83978C14.0796 4.43978 14.3096 4.02978 14.7096 3.90978C15.1096 3.79978 15.5196 4.02978 15.6296 4.42978C16.2296 6.55978 17.9196 8.24978 20.0496 8.84978C20.4496 8.95978 20.6796 9.37978 20.5696 9.77978C20.4796 10.1198 20.1796 10.3298 19.8496 10.3298Z"
              fill="#EE6900"
            />
          </svg>
          {localStorage.getItem("mobile")}
        </span>
      </div>
      <div className="enter-code">
        <input
          type="number"
          id="1"
          className="code-input"
          onKeyUp={OnKeyUpCode}
          defaultValue={""}
          autoFocus={true}
          minLength={1}
          maxLength={1}
        />
        <input
          type="number"
          id="2"
          className="code-input"
          onKeyUp={OnKeyUpCode}
          defaultValue={""}
          minLength={1}
          maxLength={1}
        />
        <input
          type="number"
          id="3"
          className="code-input"
          onKeyUp={OnKeyUpCode}
          defaultValue={""}
          minLength={1}
          maxLength={1}
        />
        <input
          type="number"
          id="4"
          className="code-input"
          onKeyUp={OnKeyUpCode}
          defaultValue={""}
          minLength={1}
          maxLength={1}
        />
        <input
          type="number"
          id="5"
          className="code-input"
          onKeyUp={OnKeyUpCode}
          defaultValue={""}
          minLength={1}
          maxLength={1}
        />
      </div>
      <div className="resend-code">
        <span>کد را دریافت نکردی؟</span>
        <MyTimer expiryTimestamp={time} type={props.type}/>
      </div>
    </div>
  );
};

export default Verify;
